export function getDeviceFingerprint() {
  if (typeof window === 'undefined') return 'server';

  const parts = [
    navigator?.userAgent || '',
    navigator?.platform || '',
    screen?.width || '',
    screen?.height || '',
    screen?.colorDepth || '',
    Intl.DateTimeFormat().resolvedOptions().timeZone || ''
  ].join('|');

  let hash = 5381;
  for (let i = 0; i < parts.length; i++) {
    hash = (hash * 33) ^ parts.charCodeAt(i);
  }

  return `fp_${(hash >>> 0).toString(16)}`;
}
